<template>
<div>
  <div v-if="catalog">
    <p class="panel-subtitle">{{ $t('tools.catalog.headerName') | capitalize }}</p>
    <q-breadcrumbs active-color="black">
      <q-breadcrumbs-el v-for="category in catalog" :key="category.id" :label="category"/>
    </q-breadcrumbs>
  </div>

  <div class="keywords" v-if="keywords">
    <div class="panel-subtitle">{{ $t('names.keywords') | capitalize }}</div>
    <q-chip
      v-for="keyword in keywords"
      :key="keyword"
      square
      v-show="keyword !== ''"
    >
      {{ keyword }}
    </q-chip>
  </div>

  <div class="legend" v-if="legend">
    <p class="panel-subtitle">{{ $t('names.legend') | capitalize }}</p>
    <div v-html="legend"></div>
  </div>

  <div v-if="downloads && downloads.length > 0">
    <p class="panel-subtitle">{{ $t('names.downloads') | capitalize }}</p>
    <q-list separator dense>
      <q-item
        v-for="download in downloads"
        v-bind:key="download.id"
      >
        <q-item-section>
          <q-item-label>{{ download.title }}</q-item-label>
          <q-item-label v-if="download.description" caption lines="2">{{ download.description }}</q-item-label>
        </q-item-section>
        <q-item-section side>
          <q-spinner v-if="openingFiles.includes(download.url)"></q-spinner>
          <q-btn
            v-else
            flat dense no-caps
            icon="search"
            @click="open(download)"
          >
            <q-tooltip>{{$t('actions.explore') | capitalize}}</q-tooltip>
          </q-btn>
        </q-item-section>
      </q-item>
    </q-list>
  </div>
</div>
</template>

<script>
import { QBreadcrumbs, QBreadcrumbsEl, QBtn, QChip, QItem, QItemSection, QItemLabel, QList, QSpinner, QTooltip } from 'quasar'
import axios from 'axios'
import { saveAs } from 'file-saver'

export default {
  props: [
    'catalog',
    'downloads',
    'keywords',
    'legend'
  ],
  components: { QBreadcrumbs, QBreadcrumbsEl, QBtn, QChip, QItem, QItemSection, QItemLabel, QList, QSpinner, QTooltip },
  data () {
    return {
      openingFiles: []
    }
  },
  methods: {
    open (download) {
      const url = download.url
      this.openingFiles.push(url)
      const headers = this.$store.getters['auth/headers']
      const conf = {
        headers: headers,
        responseType: 'arraybuffer'
      }
      axios.get(url, conf).then(response => {
        const contentType = response.headers['content-type']
        const fileBlob = new Blob([response.data], { type: contentType })
        if (this.$config.components.resultTabs.infoTab.previewContentTypes.includes(contentType)) {
          const fileURL = window.URL.createObjectURL(fileBlob)
          window.open(fileURL)
        } else {
          const fileName = url.split('/').pop()
          saveAs(fileBlob, fileName)
        }
        this.openingFiles = this.openingFiles.filter(file => file !== url)
      }).catch(error => {
        this.openingFiles = this.openingFiles.filter(file => file !== url)
        this.$except(error)
      })
    }
  }
}
</script>

<style>

</style>
